<template>
  <p class="text-sm font-normal" data-test="TP1">
    <slot />
  </p>
</template>
